import 'core-js/features/set/union';
import 'core-js/features/array/find';
import 'core-js/features/promise';
import 'core-js/features/map';
import 'core-js/features/string/pad-start';
import 'core-js/features/object/keys';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

// arirbnb ie
import 'airbnb-js-shims/target/es2015';
import 'airbnb-browser-shims/browser-only';

import React from 'react';
import ReactDOM from 'react-dom';
import i18next from 'i18next';
import './index.css';
import i18n from './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootReducer, { rootSaga } from 'modules';
import { setUser } from 'modules/auth';
import { initializePortal } from 'modules/portal';
import { initializeLocale } from 'modules/locale';
// import { tempSetUser, check } from 'modules/user';
import { setLocale, productCode, advrtsGroup } from 'lib/api/common';
import { getMenu } from 'modules/menu';
import {setProductCode, externalCode, getMembersFilter} from 'modules/common';
import { different, tokenCheck } from './lib/api/auth';
import queryString from 'query-string';

// saga 미들웨어를 생성한다.
const sagaMiddleware = createSagaMiddleware();
// saga를 store에 마운트
const store = createStore(
  rootReducer,
  // redux의 미들웨어로 sagaMiddleware 사용
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);
// saga실행
sagaMiddleware.run(rootSaga);

// function isPromise(value) {
//   return Boolean(value && typeof value.then === 'function');
// }

const setDefault = (user) => {
  const filterSeq = 4; // 관리자 필터 SEQ
  let advrtsGroupList = new Map();

  store.dispatch(setUser(user));
  store.dispatch(getMenu());
  store.dispatch(externalCode());
  store.dispatch(getMembersFilter());
  advrtsGroup({ fltSeq: filterSeq })
    .then((prdResponse) => {
      advrtsGroupList = prdResponse.data.data;
    })
    .catch((error) => {
      console.log(error.message);
    });

  productCode({ fltSeq: filterSeq })
    .then((prdResponse) => {
      const { platMenus, prdtMenus } = prdResponse.data.data;
      const platformCodeList = platMenus.map((platFormCode) => {
        const { CODE_ID, CODE_VAL } = platFormCode;
        return {
          label: i18next.t(CODE_VAL),
          value: CODE_ID,
        };
      });

      // 공통으로 쓰이는 상품 구분 코드
      const productCodeList = new Map();
      const tempValueObj = {};
      const allProductCodeList = new Map();
      for (let code in prdtMenus) {
        if (prdtMenus.hasOwnProperty(code)) {
          const curPrdt = prdtMenus[code];
          const {
            advrtsPrdtCode: value,
            advrtsPrdtName: label,
            item,
          } = curPrdt;
          const newItem = item.map((curData) => {
            const {
              ADVRTS_TP_CODE: value,
              ADVRTS_TP_NM: label,
              CODE_VAL: codeVal,
              CODE_DESC: codeDesc,
            } = curData;
            const cur = {
              label,
              value,
              codeVal,
              codeDesc,
            };
            if (typeof tempValueObj[value] === 'undefined') {
              tempValueObj[value] = 1;
              allProductCodeList.set(value, cur);
            }
            return cur;
          });
          productCodeList.set(value, {
            label,
            value,
            item: newItem,
          });
        }
      }
      store.dispatch(
        setProductCode({
          platformCodeList,
          productCodeList,
          allProductCodeList,
          advrtsGroupList,
        })
      );
    })
    .catch((error) => {
      console.log(error.message);
    });
};

function loadUser() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const path = window.location.pathname;

    if (!user || path == '/login') {
      return;
    } else {
      setDefault(user);
    }
  } catch (e) {
    console.log('localStorage is not working');
  }
}

/**
 * 컴바인 로그인함수
 * @param mobToken (String)
 * @returns {Promise<void>}
 */
const callDifferent = async (mobToken) => {
  const response = await different({ mobToken });
  const { data, success } = response.data;
  if (success) {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        localStorage.removeItem('user');
        localStorage.removeItem('adminToken');
      }
      localStorage.setItem('user', JSON.stringify(data));
      localStorage.setItem('adminToken', data.token);
      let path = '';
      if (typeof isEmbed !== 'undefined') {
        path = window.location.pathname + '?isEmbed=1';
      } else {
        path = window.location.pathname + '?isFrame=1';
      }
      window.location.replace(path);
    } catch (e) {
      console.log('localStorage is not working');
    }
  } else {
    window.location.replace('/login');
  }
};

/**
 * JWT token 체크함수
 * @returns {Promise<AxiosResponse<T>>}
 */
const callTokenCheck = async () => {
  const response = await tokenCheck();
  return response;
};

/**
 * 임베드여부 함수 체크후 이동
 * @param isEmbed (bppl)
 */
const embedCheck = (isEmbed) => {
  let path = '';
  const search = queryString.parse(window.location.search);
  let newParams = '?';
  delete search['token'];
  if (typeof isEmbed === 'undefined') {
    newParams = newParams + 'isFrame=1&';
  }
  for (let key in search) {
    if (!!key && !!search[key]) {
      newParams = newParams + key + '=' + search[key] + '&';
    }
  }
  /*
  1.0 -> 2.0으로 아이프레임 파라미터 전달 시 전달 안되는 문제가 있었음.
  이렇게되면 임베드와 프레임 타입이 동시에 넘어 올 수 있는데 확인결과 임베드 타입으로 화면에 적용됨.
   */
  path = window.location.pathname + newParams;
  // if (typeof isEmbed !== 'undefined') {
  //   path = window.location.pathname + '?isEmbed=1';
  // } else {
  //   path = window.location.pathname + '?isFrame=1';
  // }
  window.location.replace(path);
};

const { token, isEmbed } = queryString.parse(window.location.search); //구모비온에서 넘겨주는 토큰값
const userId = JSON.parse(localStorage.getItem('user'));
const mobToken = token;

// Mobon Totken : OK
if (typeof mobToken !== 'undefined') {
  // 로그인 : NO
  if (userId === null) {
    //모비온 토큰을 이용해 컴바인 로그인 시도
    callDifferent(mobToken).then(async () => {
      await embedCheck(isEmbed);
    });

    //로그인 : OK
  } else if (userId !== null) {
    // 토큰 유효성 체크
    callTokenCheck()
      .then(async (response) => {
        if (response.data.data.status === false) {
          await callDifferent(mobToken).then(async () => {
            // 임베드체크 이후 페이지 이동
            await embedCheck(isEmbed);
          });
        } else {
          embedCheck(isEmbed);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Mobon Totken : No
} else {
  /**
   * locale 설정 후 화면 렌더링(서버에서 응답 받은 후 다음 응답 하도록)
   */

  setLocale(i18n.language)
    .then(async (response) => {
      if (i18n.language === 'ko') {
        /**
         * 접속 국가별 moment locale import 변경 -
         */
        await import('moment/locale/ko');
      }
      store.dispatch(initializeLocale(i18n.language));
      store.dispatch(initializePortal());

      await loadUser();
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      ReactDOM.render(
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>,
        document.getElementById('root')
      );

      serviceWorker.unregister();
    });
}
